import React from "react";
import { useTranslation } from "react-i18next";

export const LanguageToggleButton = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "hi" : "en";
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      title="Change Language"
      className="ml-4 px-4 py-2 bg-gray-900 text-white rounded-full text-sm font-medium hover:bg-gray-800 transition"
    >
      {i18n.language === "en" ? "Change Language to Hindi" : "भाषा को अंग्रेजी में बदलें"}
    </button>
  );
};
